import {gsap} from 'gsap';
const {modalManager} = window;
class MainMenu {
  constructor(element, options = {mobileMediaQuery: '(max-width: 1000px)'}) {
    // Elements
    this.header = element;
    this.selectedIndex = null;
    this.navItems = [...element.querySelectorAll('[data-element="subnav-item"]')];
    this.searchModal = document.querySelector('[data-js-module="SearchModal"]');
    this.mobileMenuWrapper = element.querySelector('#main-menu');
    this.mobileMenuButton = element.querySelector('#menu-toggle');

    // Options
    this.options = options;
    this.init();
  }

  /**
   * Initilization functions
   */
  init() {
    this.bindDesktopEvents();
    this.bindMobileEvents();
  }

  isMobile() {
    return window.matchMedia(this.options.mobileMediaQuery).matches;
  }

  bindDesktopEvents() {
    if (this.isMobile()) return;

    this.navItems.forEach((item) => {
      const button = item.querySelector('[data-element="subnav-button"]');

      const toggle = (expanded) => {
        item.setAttribute('aria-expanded', expanded);
        button.setAttribute('aria-expanded', expanded);
        if (!expanded) button.blur();
        else {
          button.focus();
          if (this.searchModal.classList.contains('is-open')) modalManager.close('searchModal');
        }
      };

      // Store toggle for use in keydown
      item._toggle = toggle;

      item.addEventListener('mouseenter', () => toggle(true));
      item.addEventListener('mouseleave', () => toggle(false));

      // Key handler
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          // Close all others
          this.navItems.forEach((otherItem) => otherItem !== item ? otherItem._toggle?.(false) : null);

          // Toggle current open
          toggle(true);
        }
      });
    });

    this.header.addEventListener('mouseenter', () => {
      setTimeout(() => {
        document.documentElement.style.setProperty('--nav-transition', 'opacity 0s linear, visibility 0s linear');
      }, 1000);
    });
    this.header.addEventListener('mouseleave', () => {
      document.documentElement.style.setProperty('--nav-transition', 'opacity 0.2s linear, visibility 0.2s linear');
    });
  }

  bindMobileEvents() {
    if (!this.isMobile()) return;
    this.navItems.forEach((item) => {
      const button = item.querySelector('[data-element="subnav-button"]');
      const submenu = item.querySelector('[data-element="main-menu-subnav"]');

      // Mobile toggle behavior
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const isHidden = submenu.hasAttribute('hidden');
        button.setAttribute('aria-expanded', String(isHidden));
        submenu.toggleAttribute('hidden', !isHidden);
        gsap.to(submenu, {opacity: isHidden ? 1 : 0, pointerEvents: isHidden ? 'auto' : 'none'});
      });
    });

    this.mobileMenuButton.addEventListener('click', () => {
      const isExpanded = this.mobileMenuButton.getAttribute('aria-expanded') === 'true';
      this.mobileMenuWrapper.classList.toggle('main-menu__open', !isExpanded);
      document.documentElement.classList.toggle('menu-active', !isExpanded);
      this.mobileMenuButton.setAttribute('aria-expanded', String(!isExpanded));
    });
  }
}

// Start Instance
const menu = document.querySelector('[data-element="menu"]');
if (menu) new MainMenu(menu);
